import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@bemap/utils';
import { LoadingScreen } from '@bemap/ui';

const CallbackPage: FC = () => {
  const { isAuthenticated, user, homepage, isRedirecting } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isRedirecting) {
      return;
    }

    if (isAuthenticated && user) {
      console.log('Redirecting to homepage:', homepage);
      navigate(homepage, { replace: true });
    } else {
      console.log('Redirecting to login');
      navigate('/login', { replace: true });
    }
  }, [isAuthenticated, user, homepage, navigate, isRedirecting]);

  return <LoadingScreen />;
};

export default CallbackPage; 